/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLoaderQuarter = createReactComponent("loader-quarter", "IconLoaderQuarter", [
  ["path", { d: "M12 6l0 -3", key: "svg-0" }],
  ["path", { d: "M6 12l-3 0", key: "svg-1" }],
  ["path", { d: "M7.75 7.75l-2.15 -2.15", key: "svg-2" }]
]);

export { IconLoaderQuarter as default };
//# sourceMappingURL=IconLoaderQuarter.js.map
